/**
 * The accounts that get admin access (the in-app admin settings section on
 * staging/production, and the server-side admin oRPC procedures). Lives in a
 * client-safe constants package so both the client gate
 * (`useShowAdminSettingsSection`) and the server gate share one source of truth.
 *
 * `leon@leonsilicon.com` is the maintainer account; `demo+admin@haniverse.app` is
 * the shared demo/admin account used to reach the in-app dev tools (e.g. the
 * Grapheme File Editor) on real deployed builds without shipping them to every
 * user.
 */
export const ADMIN_USER_EMAILS = ["leon@leonsilicon.com", "demo+admin@haniverse.app"] as const;

/**
 * The primary maintainer admin account. Prefer {@link isAdminUserEmail} for
 * membership checks — there is more than one admin account ({@link ADMIN_USER_EMAILS}).
 */
export const ADMIN_USER_EMAIL = ADMIN_USER_EMAILS[0];

const ADMIN_USER_EMAIL_SET = new Set<string>(ADMIN_USER_EMAILS);

/** Case-insensitive check that an email belongs to one of the admin accounts. */
export function isAdminUserEmail(email: string | null | undefined): boolean {
  return email != null && ADMIN_USER_EMAIL_SET.has(email.toLowerCase());
}
